import { downloadFile, format, mapPaginationParamsToServer } from "@/shared";

export const exportKits = async (paginationParams) => {
    const fileName = `exported_kits_${format(new Date(), "dd_MM_yyyy-HH_mm")}`;

    await downloadFile("/kit/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
    });
};
